import React from 'react';

import fold from "../img/fold.svg"
import unfold from "../img/unfold.svg"
import '../css/scrm.table.css'

class Features extends React.Component
{
    constructor( props )
    {

        super (props)

        this.state = {
            features:this.props.features,
            className:this.props.className,
            isMore:false,
            MoreBtnHidden:true
        }

        this.clickMore = this.clickMore.bind(this)
    }

    componentWillReceiveProps(nextprops)
    {
        if(nextprops.features.length === 0)
        {
            return null;
        }
        
        if(nextprops.features.length <= 15)
        {
            this.setState({
                MoreBtnHidden:false
            })
        }
    }

    clickMore()
    {
        let {isMore} = this.state;
        this.setState({isMore:!isMore},()=>{
            this.props.changeMore()
        })
    }

    render()
    {
        
        let {features, className} =this.props;
        let { isMore, MoreBtnHidden } = this.state;
        if( features!==undefined && features.length>0 )
        {
            return(
                <div style={{position:"relative"}}>
                    <span className={MoreBtnHidden?isMore?"label-content-active":"label-content":"label-content-active"}>
                        {
                            features.map((item,index)=>{
                                return(
                                    <div className={className} key={index}>
                                        <span>{item.name}</span>
                                    </div>
                                )
                            })
                        }
                        
                    </span>
                    {
                        MoreBtnHidden?<span style={{color:"#016eff",display:"inline-block",position:"absolute",right:"-50px",bottom:"11px"}} className='click' onClick={()=>{this.clickMore()}}>{isMore?<span><img src={fold}/> 收起</span>:<span><img src={unfold}/> 展开</span>}</span>:null
                    }
                    
                </div>
            );
        }
        else
        {
            return <span></span>;
        }
    }
}
export default Features
